import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const RenderName = ({userName}) => (
    <b className="seller-link">{userName}</b>
);

const RenderNameWithLink = ({userName}) => (
    <a href={`/${userName}`} className="seller-link" rel="nofollow,noindex">{userName}</a>
);

/**
 * @function
 * @name ProfileLink
 * @param {String} userName - the user's name
 * @param {Boolean} noLink - text only, don't make it a link
 * Returns the markup of the user profile link
 */

const ProfileLink = ({userName, noLink}) => (
    noLink
        ? <RenderName userName={userName}/>
        : <RenderNameWithLink userName={userName}/>
);

ProfileLink.propTypes = {
    userName: PropTypes.string,
    noLink: PropTypes.bool
};

export default ProfileLink;


// WEBPACK FOOTER //
// ./src/components/profile_link/index.js